import { FilterType, Filter, FilterKey } from 'types';
import { IGetFilterGroupsProps } from '../../types';

import { CompleteTypes } from '../types';

const IncompleteOptions = [
  {
    label: 'Information check',
    value: CompleteTypes.INFORMATION_CHECK,
  },
  {
    label: 'Finance plan',
    value: CompleteTypes.FINANCE_PLAN,
  },
  {
    label: 'Documents',
    value: CompleteTypes.DOCUMENTS,
  },
  {
    label: 'Questionnaire',
    value: CompleteTypes.INTERVIEW,
  },
  {
    label: 'All',
    value: CompleteTypes.ALL,
  },
];

const key = FilterKey.INCOMPLETE;
export const getIncompleteFilter = ({ activeFilters }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  const options = IncompleteOptions.map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });
  return {
    name: 'Incomplete',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: false,
    options: {
      SELECT_MANY: options,
    },
  };
};
